import React from 'react'
import {Navigate, Route, Routes, Outlet, useParams} from 'react-router-dom'
import {PageTitle} from '@/_metronic/layout/core'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import Header from './components/Header'
import Overview from './components/Overview'
import Reports from './components/Reports'
import Settings from './components/Settings'
import Sponsorship from './components/Sponsorship'
import Statement from './components/Statement'
import Logs from './components/Logs'
import Auths from './components/Auth'
import {CustomerProvider} from './CustomerContext'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}, {
  title: 'Customers',
  path: '/p2c/customers',
}])


const ViewWrapper = () => {
  const {id} = useParams()

  if (!id) {
    return (<>No customer id</>)
  }

  return (
    <CustomerProvider customerId={id}>
      <Routes>
        <Route
          element={
            <>
              <Header/>
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Overview</PageTitle>
                <Overview/>
              </>
            }
          />
          <Route
            path='reports'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Reports</PageTitle>
                <Reports/>
              </>
            }
          />

          <Route
            path='statements'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Statement</PageTitle>
                <Statement />
              </>
            }
          />

          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />

          <Route
            path='auth'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Logs</PageTitle>
                <Auths />
              </>
            }
          />
          
          <Route
            path='logs'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Logs</PageTitle>
                <Logs />
              </>
            }
          />

          <Route
            path='sponsorship'
            element={
              <>
                <PageTitle breadcrumbs={Breadcrumbs}>Sponsorship</PageTitle>
                <Sponsorship />
              </>
            }
          />

          <Route index element={<Navigate to={`/customers/${id}/overview`} />} />
        </Route>
      </Routes>
    </CustomerProvider>
  )
}

export default ViewWrapper
